import { useEffect } from 'react';

import disclosureInitializer from '../../../../Shared/components-v2/footer/disclosureInitializer';
import { ProductSelectionOptionsQuery } from '../graphql/productSelectionOptions.generated';

export const useDisclosuresUpdate = (options?: ProductSelectionOptionsQuery['productOnboardingOptions']) => {
  useEffect(() => {
    if (options) {
      options.forEach((option, index) => {
        if (option.disclosure) {
          disclosureInitializer.update(`productSelection-${option.id}-${index}`, option.disclosure);
        }
      });
    }

    return () => {
      if (options) {
        options.forEach((option, index) => {
          disclosureInitializer.update(`productSelection-${option.id}-${index}`, undefined);
        });
      }
    };
  }, [options]);
};
